import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
 apiKey: "AIzaSyDUplZtLgHarvXHzv_T_GZFqKN-tXeN93E",
  authDomain: "commitnexus-dd7f9.firebaseapp.com",
  projectId: "commitnexus-dd7f9",
  storageBucket: "commitnexus-dd7f9.firebasestorage.app",
  messagingSenderId: "268888471410",
  appId: "1:268888471410:web:e797c3ea76f7a46d934feb",
  measurementId: "G-HKPN5WR2JQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
